import { useQuery } from '@apollo/client/react';

import { GetPlanFeaturesDocument, PlanFeatureCode } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';

export const usePlanFeature = (feature: PlanFeatureCode) => {
  const { data, loading } = useQuery(GetPlanFeaturesDocument);
  const features = data ? getMe(data)?.planFeatureCodes || [] : [];
  const hasEnabledFeature = features.includes(feature);

  return { loading, hasEnabledFeature };
};
